/**
 * ICU message strings for pluralization and interpolation.
 * Used by IntlProvider as the message catalog and by t() for lookups.
 */

export const messages: Record<string, string> = {
  item: "{count, plural, =0 {0 items} one {1 item} other {{count} items}}",
  etsyOrders:
    "{count, plural, =0 {0 {platform} orders} one {1 {platform} order} other {{count} {platform} orders}}",
  days: "{n, plural, =0 {today} one {tomorrow} other {within {n} days}}",
  daysPast: "{n, plural, =0 {today} one {yesterday} other {{n} days ago}}",
  minute: "{count, plural, =0 {0 minutes} one {a minute} other {{count} minutes}}",
  image: "{count, plural, =0 {0 images} one {1 image} other {{count} images}}",
  transfer: "{count, plural, =0 {0 Transfers} one {1 Transfer} other {{count} Transfers}}",
  "billingMessage.customMadeAndBlanks":
    "Custom-made items (Transfers and Print) are billed immediately. Blank items are billed when shipped."
};
